import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

export interface BannerCardTranslationValues {
	headline: Object[];
	description: Object[];
	action: Object[];
}

export const NO_TRANSLATION_VALUES: BannerCardTranslationValues = {
	headline: [],
	description: [],
	action: []
};

@Component({
	selector: "banner-card",
	templateUrl: "./banner-card.component.html",
	styleUrls: ["./banner-card.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BannerCardComponent {
	@Input()
	public iconSrc: string = null;
	@Input()
	public translationKeyPrefix:
		| "savings_plan_banner"
		| "debit_card_banner"
		| "security_2fa_banner"
		| "bci_banner"
		| string;
	@Input() customTranslationDescriptionKey: string = null;
	@Input()
	public translationValues: Partial<BannerCardTranslationValues> = NO_TRANSLATION_VALUES;
	@Input() bannerTitle: string = null;
	@Input() bannerDescription: string = null;
	@Input() bannerButtonText: string = null;
	@Input() customClass: string = null;
	@Input() actionBtnType: "normal" | "inverse" = "inverse";
	@Output()
	public actionClicked: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	public dismissClicked: EventEmitter<void> = new EventEmitter<void>();
}
